import {en} from "./translations.en";
import {fr} from "./translations.fr";

export const translations = {
  en: {
    signIn: en,
  },
  fr: {
    signIn: fr,
  },
};
